import { render, staticRenderFns } from "./ResellerModuleLayout.vue?vue&type=template&id=8b5a319e"
import script from "./ResellerModuleLayout.vue?vue&type=script&lang=js"
export * from "./ResellerModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports